export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('D:/zwtool/github2025/taichu-pc/src/pages/index.vue'),
    /* no children */
    meta: {
      "layout": "login"
    }
  },
  {
    path: '/contact',
    name: '/contact',
    component: () => import('D:/zwtool/github2025/taichu-pc/src/pages/contact.vue'),
    /* no children */
    meta: {
      "layout": "login"
    }
  },
  {
    path: '/first',
    name: '/first',
    component: () => import('D:/zwtool/github2025/taichu-pc/src/pages/first.vue'),
    /* no children */
    meta: {
      "layout": "login"
    }
  },
  {
    path: '/home',
    name: '/home',
    component: () => import('D:/zwtool/github2025/taichu-pc/src/pages/home.vue'),
    /* no children */
    meta: {
      "layout": "login"
    }
  },
  {
    path: '/introduction',
    name: '/introduction',
    component: () => import('D:/zwtool/github2025/taichu-pc/src/pages/introduction.vue'),
    children: [
      {
        path: 'introduction-sec1',
        name: '/introduction/introduction-sec1',
        component: () => import('D:/zwtool/github2025/taichu-pc/src/pages/introduction/introduction-sec1.vue'),
        /* no children */
        meta: {
          "layout": "login"
        }
      },
      {
        path: 'introduction-sec2',
        name: '/introduction/introduction-sec2',
        component: () => import('D:/zwtool/github2025/taichu-pc/src/pages/introduction/introduction-sec2.vue'),
        /* no children */
        meta: {
          "layout": "login"
        }
      },
      {
        path: 'introduction-sec3',
        name: '/introduction/introduction-sec3',
        component: () => import('D:/zwtool/github2025/taichu-pc/src/pages/introduction/introduction-sec3.vue'),
        /* no children */
        meta: {
          "layout": "login"
        }
      }
    ],
    meta: {
      "layout": "login"
    }
  },
  {
    path: '/joinUs',
    name: '/joinUs',
    component: () => import('D:/zwtool/github2025/taichu-pc/src/pages/joinUs.vue'),
    /* no children */
    meta: {
      "layout": "login"
    }
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('D:/zwtool/github2025/taichu-pc/src/pages/login.vue'),
    /* no children */
    meta: {
      "layout": "login"
    }
  },
  {
    path: '/projects',
    name: '/projects',
    component: () => import('D:/zwtool/github2025/taichu-pc/src/pages/projects.vue'),
    /* no children */
    meta: {
      "layout": "login"
    }
  },
  {
    path: '/solutions',
    name: '/solutions',
    component: () => import('D:/zwtool/github2025/taichu-pc/src/pages/solutions.vue'),
    /* no children */
    meta: {
      "layout": "login"
    }
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

